import { render, staticRenderFns } from "./commercialManager.vue?vue&type=template&id=01dd8ea7&scoped=true"
import script from "./commercialManager.vue?vue&type=script&lang=js"
export * from "./commercialManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd8ea7",
  null
  
)

export default component.exports